import * as angular from 'angular';

class ReportViewDetailsPresenterController implements angular.IOnInit {
  accountId: string;
  runIdUrlParam: string;

  static $inject = ['$stateParams'];

  constructor(private $stateParams: { [x: string]: string }) {}

  $onInit(): void {
    this.runIdUrlParam = this.$stateParams['runId'];
    this.accountId = this.$stateParams['account'];
  }
}

export const ID = 'reportDetailsPresenter';

export const reportDetailsPresenter: angular.IComponentOptions = {
  template: `
    <report-browser run-id-url-param="ctrl.runIdUrlParam" account-id="ctrl.accountId"></report-browser>
    <div
      class="report-details-container"
      ui-view
    >
    </div>`,
  controller: ReportViewDetailsPresenterController,
  controllerAs: 'ctrl',
};
